<template>
  <el-dialog :visible.sync="dialogVisible" width="1355px" :show-close="false">
    <img
      class="close-img"
      alt="close-icon.png"
      @click="dialogVisible = false"
      src="@/assets/img/images/icon/close-icon.png"
    />
    <p class="p1">
      {{ $t("user_assets.web_record.title") }}
      <span
        :class="[{ sel: tagShow === 'recharge' }]"
        @click="changeTag('recharge')"
        >{{ $t("user_assets.web_record.recharge") }}</span
      >
      <span
        :class="[{ sel: tagShow === 'withdraw' }]"
        @click="changeTag('withdraw')"
        >{{ $t("user_assets.web_record.withdraw") }}</span
      >
      <span
        :class="[{ sel: tagShow === 'transfer' }]"
        @click="changeTag('transfer')"
        >{{ $t("user_assets.web_record.transfer") }}</span
      >
      <span :class="[{ sel: tagShow === 'mall' }]" @click="changeTag('mall')">{{
        $t("user_assets.web_record.mall")
      }}</span>
      <span :class="[{ sel: tagShow === 'ctc' }]" @click="changeTag('ctc')">{{
        $t("user_assets.web_record.transaction")
      }}</span>
      <span
        :class="[{ sel: tagShow === 'other' }]"
        @click="changeTag('other')"
        >{{ $t("user_assets.web_record.other") }}</span
      >
    </p>
    <div class="filter-bar" v-if="tagShow === 'mall'">
      <div
        class="filter-item filter-item-coin"
        @click.stop="toggleCoinTypePicker"
      >
        <span class="filter-label">{{
          $t("user_assets.web_record.coin_type")
        }}</span>
        <span class="filter-value">{{
          coinType === "" ? $t("user_assets.web_record.all") : coinType | replaceUSDT
        }}</span>
        <span class="filter-arrow" :class="{ open: showCoinTypePicker }"
          >▼</span
        >
        <div class="coin-type-dropdown" v-if="showCoinTypePicker">
          <div
            class="coin-option"
            :class="{ active: coinType === '' }"
            @click.stop="selectCoinType('')"
          >
            <span class="coin-text">{{
              $t("user_assets.web_record.all")
            }}</span>
          </div>
          <div
            v-for="coin in coinTypes"
            :key="coin"
            class="coin-option"
            :class="{ active: coinType === coin }"
            @click.stop="selectCoinType(coin)"
          >
            <span class="coin-text">{{ coin | replaceUSDT }}</span>
          </div>
        </div>
      </div>
      <div
        class="filter-item filter-item-status"
        @click.stop="toggleFlowTypePicker"
      >
        <span class="filter-label">{{
          $t("user_assets.web_record.flow_type")
        }}</span>
        <span class="filter-value">{{ getFlowTypeLabel(flowType) }}</span>
        <span class="filter-arrow" :class="{ open: showFlowTypePicker }"
          >▼</span
        >
        <div class="flow-type-dropdown" v-if="showFlowTypePicker">
          <div
            class="flow-type-option"
            :class="{ active: flowType === '' }"
            @click.stop="selectFlowType('')"
          >
            <span class="flow-type-text">{{
              $t("user_assets.web_record.all")
            }}</span>
          </div>
          <div
            class="flow-type-option"
            :class="{ active: flowType === 'mall_pay' }"
            @click.stop="selectFlowType('mall_pay')"
          >
            <span class="flow-type-text">{{
              $t("user_assets.web_record.mall_pay")
            }}</span>
          </div>
          <div
            class="flow-type-option"
            :class="{ active: flowType === 'mall_distribute' }"
            @click.stop="selectFlowType('mall_distribute')"
          >
            <span class="flow-type-text">{{
              $t("user_assets.web_record.mall_distribute")
            }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="box" @click="closeDropdowns">
      <template v-if="tagShow === 'recharge'">
        <NoData v-if="rechargeTable.length <= 0" />
        <el-table
          v-else
          ref="record_recharge_table"
          :data="rechargeTable"
          style="width: 100%"
          header-cell-class-name="table-head"
          cell-class-name="table-cell"
        >
          <el-table-column
            align="center"
            width="220"
            :label="$t('user_assets.web_record.time')"
          >
            <template slot-scope="scope">
              <label style="color: #a0aac1">{{
                dateFormatter(
                  new Date(scope.row.createTime),
                  "yyyy-MM-dd hh:mm:ss",
                )
              }}</label>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            width="160"
            :label="$t('user_assets.web_record.type')"
          >
            <template slot-scope="scope">
              {{ $t("user_assets.web_record.recharge") }}-{{
                scope.row.assetType | replaceUSDT
              }}
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            width="240"
            :label="$t('user_assets.web_record.amount')"
          >
            <template slot-scope="scope">
              <label style="color: #a0aac1">{{ scope.row.value }}</label>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            width="140"
            :label="$t('user_assets.web_record.status')"
          >
            <template slot-scope="scope">
              <label class="font_color_green" v-if="scope.row.status === 1">
                {{ scope.row.statusStr }}
              </label>
              <label style="color: #000146" v-else>
                {{ scope.row.statusStr }}
              </label>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            :label="$t('user_assets.web_record.recharge_address')"
          >
            <template slot-scope="scope">
              <label style="color: #a0aac1">
                {{
                  scope.row.assetType === "HKD"
                    ? scope.row.toAddress
                    : scope.row.toAddress
                }}
              </label>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          v-if="rechargeTotal > 0"
          class="pagination-box"
          background
          layout="prev, pager, next"
          :total="rechargeTotal"
          @current-change="getRechargeTable"
          :current-page.sync="rechargeFilter.page"
          :page-size="rechargeFilter.rows"
        />
      </template>
      <template v-if="tagShow === 'withdraw'">
        <NoData v-if="withdrawTable.length <= 0" />
        <el-table
          v-else
          ref="record_recharge_table"
          :data="withdrawTable"
          style="width: 100%"
          header-cell-class-name="table-head"
          cell-class-name="table-cell"
        >
          <el-table-column
            align="center"
            width="220"
            :label="$t('user_assets.web_record.time')"
          >
            <template slot-scope="scope">
              <label style="color: #a0aac1">{{
                dateFormatter(
                  new Date(scope.row.createTime),
                  "yyyy-MM-dd hh:mm:ss",
                )
              }}</label>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            width="160"
            :label="$t('user_assets.web_record.type')"
          >
            <template slot-scope="scope">
              {{ $t("user_assets.web_record.withdraw") }}-{{
                scope.row.assetType | replaceUSDT
              }}
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            width="240"
            :label="$t('user_assets.web_record.amount')"
          >
            <template slot-scope="scope">
              <label style="color: #a0aac1">{{ scope.row.value }}</label>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            width="140"
            :label="$t('user_assets.web_record.status')"
          >
            <template slot-scope="scope">
              {{ getWithdrawStatus(scope.row.status) }}
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            :label="$t('user_assets.web_record.withdraw_address')"
          >
            <template slot-scope="scope">
              <label style="color: #a0aac1">{{ scope.row.toAddress }}</label>
            </template>
          </el-table-column>
          <el-table-column
            width="70"
            align="center"
            prop="operation"
            :label="$t('user_assets.web_record.operation')"
          >
            <template slot-scope="scope">
              <span
                v-if="scope.row.status === 1"
                class="font_color_green"
                style="cursor: pointer"
                @click="cancelWithdraw(scope.row.id)"
                >{{ $t("user_assets.web_record.cancel") }}</span
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          v-if="withdrawTotal > 0"
          class="pagination-box"
          background
          layout="prev, pager, next"
          :total="withdrawTotal"
          @current-change="getWithdrawTable"
          :current-page.sync="withdrawFilter.page"
          :page-size="withdrawFilter.rows"
        />
      </template>
      <template v-if="tagShow === 'transfer'">
        <NoData v-if="transferTable.length <= 0" />
        <el-table
          v-else
          :data="transferTable"
          style="width: 100%"
          header-cell-class-name="table-head"
          cell-class-name="table-cell"
        >
          <el-table-column
            align="center"
            width="220"
            :label="$t('user_assets.web_record.time')"
          >
            <template slot-scope="scope">
              <label style="color: #a0aac1">{{
                dateFormatter(
                  new Date(scope.row.createTime),
                  "yyyy-MM-dd hh:mm:ss",
                )
              }}</label>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            width="160"
            :label="$t('user_assets.web_record.type')"
          >
            <template slot-scope="scope">
              {{ $t("user_assets.web_record.transfer") }}-{{
                scope.row.assetType | replaceUSDT
              }}
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            width="240"
            :label="$t('user_assets.web_record.amount')"
          >
            <template slot-scope="scope">
              <label style="color: #a0aac1"
                >{{ scope.row.value }} {{ scope.row.assetType | replaceUSDT }}</label
              >
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            width="140"
            :label="$t('user_assets.web_record.status')"
          >
            <template slot-scope="scope">
              <label class="font_color_green">{{
                $t("user_assets.web_record.completed")
              }}</label>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          v-if="transferTotal > 0"
          class="pagination-box"
          background
          layout="prev, pager, next"
          :total="transferTotal"
          @current-change="getTransferTable"
          :current-page.sync="transferFilter.page"
          :page-size="transferFilter.rows"
        />
      </template>
      <template v-if="tagShow === 'mall'">
        <NoData v-if="mallTable.length <= 0" />
        <el-table
          v-else
          :data="mallTable"
          style="width: 100%"
          header-cell-class-name="table-head"
          cell-class-name="table-cell"
        >
          <el-table-column
            align="center"
            width="220"
            :label="$t('user_assets.web_record.time')"
          >
            <template slot-scope="scope">
              <label style="color: #a0aac1">{{
                dateFormatter(
                  new Date(scope.row.createTime),
                  "yyyy-MM-dd hh:mm:ss",
                )
              }}</label>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            :label="$t('user_assets.web_record.type')"
          >
            <template slot-scope="scope">
              {{ scope.row.orderId }}-{{ scope.row.assetType | replaceUSDT }}
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            width="240"
            :label="$t('user_assets.web_record.amount')"
          >
            <template slot-scope="scope">
              <label style="color: #a0aac1"
                >{{ scope.row.balanceAvailableChange }}
                {{ scope.row.assetType | replaceUSDT }}</label
              >
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            width="140"
            :label="$t('user_assets.web_record.status')"
          >
            <template slot-scope="scope">
              <label>{{
                scope.row.flowType === "mall_pay"
                  ? $t("user_assets.web_record.mall_pay")
                  : $t("user_assets.web_record.mall_distribute")
              }}</label>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          v-if="mallTotal > 0"
          class="pagination-box"
          background
          layout="prev, pager, next"
          :total="mallTotal"
          @current-change="getMallTable"
          :current-page.sync="mallFilter.page"
          :page-size="mallFilter.rows"
        />
      </template>
      <template v-if="tagShow === 'ctc'">
        <NoData v-if="ctcTable.length <= 0" />
        <el-table
          v-else
          :data="ctcTable"
          style="width: 100%"
          header-cell-class-name="table-head"
          cell-class-name="table-cell"
        >
          <el-table-column
            width="220"
            :label="$t('user_assets.web_record.time')"
          >
            <template slot-scope="scope">
              <label style="color: #a0aac1">{{
                dateFormatter(new Date(scope.row.time), "yyyy-MM-dd hh:mm:ss")
              }}</label>
            </template>
          </el-table-column>
          <el-table-column
            width="160"
            :label="$t('user_assets.web_record.type')"
          >
            <template slot-scope="scope">
              {{
                scope.row.directionStr === "BUY"
                  ? $t("user_assets.web_record.buy")
                  : $t("user_assets.web_record.sell")
              }}-{{ scope.row.coinSymbol }}
            </template>
          </el-table-column>
          <el-table-column
            width="180"
            :label="$t('user_assets.web_record.amount')"
          >
            <template slot-scope="scope">
              <label style="color: #a0aac1">{{ scope.row.tradedAmount }}</label>
            </template>
          </el-table-column>
          <el-table-column
            width="120"
            prop="status"
            :label="$t('user_assets.web_record.status')"
          >
            <template slot-scope="scope">
              {{
                scope.row.statusStr === "COMPLETED"
                  ? $t("user_assets.web_record.success")
                  : $t("user_assets.web_record.fail")
              }}
            </template>
          </el-table-column>
          <!-- <el-table-column :label="$t('sellOrder.balance')">
            <template slot-scope="scope">
              {{ scope.row.balance }}
            </template>
          </el-table-column> -->
          <el-table-column prop="dk" :label="$t('order_manage.fee')">
            <template slot-scope="scope">
              {{ scope.row.fee }}&nbsp;{{ scope.row.feeType | replaceUSDT }}
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          v-if="ctcTotal > 0"
          class="pagination-box"
          background
          layout="prev, pager, next"
          :total="ctcTotal"
          @current-change="getCtcTable"
          :current-page.sync="ctcFilter.page"
          :page-size="ctcFilter.rows"
        />
      </template>
      <template v-if="tagShow === 'other'">
        <NoData v-if="otherTable.length <= 0" />
        <el-table
          v-else
          :data="otherTable"
          style="width: 100%"
          header-cell-class-name="table-head"
          cell-class-name="table-cell"
        >
          <el-table-column
            width="220"
            +
            :label="$t('user_assets.web_record.time')"
          >
            <template slot-scope="scope">
              <label style="color: #a0aac1">{{
                dateFormatter(
                  new Date(scope.row.createTime),
                  "yyyy-MM-dd hh:mm:ss",
                )
              }}</label>
            </template>
          </el-table-column>
          <el-table-column
            width="180"
            :label="$t('user_assets.web_record.type')"
          >
            <template slot-scope="scope">
              {{
                scope.row.type === "burstBlock"
                  ? $t("user_assets.web_record.burst_block")
                  : $t("user_assets.web_record.rebate")
              }}
              -{{ scope.row.currency }}
            </template>
          </el-table-column>
          <el-table-column
            width="180"
            :label="$t('user_assets.web_record.amount')"
          >
            <template slot-scope="scope">
              <label style="color: #a0aac1">{{ scope.row.amount }}</label>
            </template>
          </el-table-column>
          <el-table-column
            width="160"
            :label="$t('user_assets.web_record.status')"
          >
            <template slot-scope="scope">
              {{ $t("user_assets.web_record.complete") }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('user_assets.web_record.other')">
            <template slot-scope="scope">
              <label
                style="color: #42cb83"
                v-if="scope.row.type === 'burstBlock'"
              >
                <router-link
                  :to="'/userAssets/blockDetail?id=' + scope.row.id"
                  >{{ $t("user_assets.web_record.check_detail") }}</router-link
                >
              </label>
              <label v-else>- -</label>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          v-if="otherTotal > 0"
          class="pagination-box"
          background
          layout="prev, pager, next"
          :total="otherTotal"
          @current-change="getOtherTable"
          :current-page.sync="otherFilter.page"
          :page-size="otherFilter.rows"
        />
      </template>
    </div>
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";
import NoData from "@/components/NoData";
export default {
  components: {
    NoData,
  },
  computed: {
    ...mapState(["user", "errorCode"]),
  },
  data() {
    return {
      dialogVisible: false,
      tagShow: "recharge",
      beforeTable: "", //前一次展开行的表格
      beforeRow: null, //前一次展开行
      coinType: "",
      showCoinTypePicker: false,
      coinTypes: [],
      flowType: "",
      showFlowTypePicker: false,
      rechargeFilter: {
        page: 1,
        rows: 10,
      },
      rechargeTotal: 0,
      rechargeTable: [],
      withdrawFilter: {
        page: 1,
        rows: 10,
      },
      withdrawTotal: 0,
      withdrawTable: [],
      transferFilter: {
        page: 1,
        rows: 10,
      },
      transferTotal: 0,
      transferTable: [],
      mallFilter: {
        page: 1,
        rows: 10,
      },
      mallTotal: 0,
      mallTable: [],
      ctcFilter: {
        page: 1,
        rows: 10,
      },
      ctcTotal: 0,
      ctcTable: [],
      otcFilter: {
        page: 1,
        rows: 10,
      },
      otcTotal: 0,
      otcTable: [],
      otherFilter: {
        page: 1,
        rows: 10,
      },
      otherTotal: 0,
      otherTable: [],
    };
  },
  // created() {
  //   this.tagShow = this.$route.query.tagShow
  //     ? this.$route.query.tagShow
  //     : "recharge";
  //   this.getTableData();
  // },
  methods: {
    initDialog(assetType) {
      console.log("tagShow", this.$route.query.tagShow);
      this.dialogVisible = true;
      this.tagShow = this.$route.query.tagShow
        ? this.$route.query.tagShow
        : "recharge";
      if (assetType) {
        this.coinType = assetType;
      }
      this.loadCoinTypes();
      this.getTableData();
    },
    changeTag(tagShow) {
      this.tagShow = tagShow;
      this.showCoinTypePicker = false;
      this.showFlowTypePicker = false;
      if (tagShow !== "mall") {
        this.flowType = "";
      }
      this.getTableData();
    },
    loadCoinTypes() {
      this.$axios
        .post("/userAssets/queryAssetList", {
          accountType: "spot",
          legalCurrency: "HKD",
        })
        .then((res) => {
          if (
            res.data.code === this.errorCode.ok &&
            res.data.data &&
            res.data.data.userAssetRsps
          ) {
            this.coinTypes =
              res.data.data.userAssetRsps.map((item) => item.assetType) || [];
          }
        })
        .catch((err) => {
          console.log("获取币种列表失败:", err);
        });
    },
    toggleCoinTypePicker() {
      this.showCoinTypePicker = !this.showCoinTypePicker;
    },
    selectCoinType(coinType) {
      if (this.coinType !== coinType) {
        this.coinType = coinType;
        this.mallFilter.page = 1;
        this.mallTable = [];
        this.getMallTable();
      }
      this.showCoinTypePicker = false;
    },
    getFlowTypeLabel(flowType) {
      switch (flowType) {
        case "mall_pay":
          return this.$t("user_assets.web_record.mall_pay");
        case "mall_distribute":
          return this.$t("user_assets.web_record.mall_distribute");
        default:
          return this.$t("user_assets.web_record.all");
      }
    },
    toggleFlowTypePicker() {
      this.showFlowTypePicker = !this.showFlowTypePicker;
    },
    selectFlowType(flowType) {
      if (this.flowType !== flowType) {
        this.flowType = flowType;
        this.mallFilter.page = 1;
        this.mallTable = [];
        this.getMallTable();
      }
      this.showFlowTypePicker = false;
    },
    closeDropdowns() {
      this.showCoinTypePicker = false;
      this.showFlowTypePicker = false;
    },
    getTableData() {
      switch (this.tagShow) {
        case "recharge":
          this.getRechargeTable();
          break;
        case "withdraw":
          this.getWithdrawTable();
          break;
        case "transfer":
          this.getTransferTable();
          break;
        case "mall":
          this.getMallTable();
          break;
        case "ctc":
          this.getCtcTable();
          break;
        case "otc":
          this.getOtcTable();
          break;
        case "other":
          this.getOtherTable();
          break;
      }
    },
    getRechargeTable() {
      this.$axios
        .post("/userAssets/tranRecord", {
          coinType: this.coinType,
          page: this.rechargeFilter.page,
          queryType: "deposit",
          rows: this.rechargeFilter.rows,
        })
        .then((res) => {
          this.rechargeTable = res.data.data.deposit.rows;
          this.rechargeTotal = res.data.data.deposit.total;
        });
    },
    getWithdrawTable() {
      this.$axios
        .post("/userAssets/tranRecord", {
          coinType: this.coinType,
          page: this.withdrawFilter.page,
          queryType: "withdraw",
          rows: this.withdrawFilter.rows,
        })
        .then((res) => {
          this.withdrawTable = res.data.data.withdraw.rows;
          this.withdrawTotal = res.data.data.withdraw.total;
        });
    },
    getWithdrawStatus(status) {
      switch (status) {
        case 1:
          return this.$t("user_assets.web_record.status_applied");
        case 2:
          return this.$t("user_assets.web_record.status_checked");
        case 3:
          return this.$t("user_assets.web_record.status_send");
        case 4:
          return this.$t("user_assets.web_record.status_confirm");
        case 5:
          return this.$t("user_assets.web_record.status_withdraw");
        case 6:
          return this.$t("user_assets.web_record.status_refused");
        case 7:
          return this.$t("user_assets.web_record.status_cancel");
      }
    },
    getCtcTable() {
      this.$axios
        .post("/userAssets/tranRecord", {
          coinType: this.coinType,
          page: this.ctcFilter.page,
          queryType: "trade",
          rows: this.ctcFilter.rows,
        })
        .then((res) => {
          this.ctcTable = res.data.data.trade.rows;
          this.ctcTotal = res.data.data.trade.total;
        });
    },
    getTransferTable() {
      this.$axios
        .post("/userAssets/tranRecord", {
          coinType: this.coinType,
          page: this.transferFilter.page,
          queryType: "transfer",
          rows: this.transferFilter.rows,
        })
        .then((res) => {
          this.transferTable = res.data.data.transfer.rows;
          this.transferTotal = res.data.data.transfer.total;
        });
    },
    getMallTable() {
      this.$axios
        .post("/userAssets/tranRecord", {
          coinType: this.coinType,
          page: this.mallFilter.page,
          queryType: "mall",
          rows: this.mallFilter.rows,
          flowType: this.flowType,
        })
        .then((res) => {
          this.mallTable = res.data.data.mall.rows;
          this.mallTotal = res.data.data.mall.total;
        });
    },
    getOtcTable() {
      this.$axios
        .post("/userAssets/tranRecord", {
          coinType: this.coinType,
          page: this.otcFilter.page,
          queryType: "otc",
          rows: this.otcFilter.rows,
        })
        .then((res) => {
          this.otcTable = res.data.data.otc.rows;
          this.otcTotal = res.data.data.otc.total;
        });
    },
    getOtherTable() {
      this.$axios
        .post("/userAssets/tranRecord", {
          coinType: this.coinType,
          page: this.otherFilter.page,
          queryType: "other",
          rows: this.otherFilter.rows,
        })
        .then((res) => {
          this.otherTable = res.data.data.other.rows;
          this.otherTotal = res.data.data.other.total;
        });
    },
    openExpand(row, ref) {
      if (this.beforeRow && this.beforeTable) {
        this.$refs[this.beforeTable].toggleRowExpansion(this.beforeRow, false); //收起之前的展开行
      }
      this.$refs[ref].toggleRowExpansion(row, true);
      this.beforeTable = ref;
      this.beforeRow = row;
    },
    //关闭之前的展开行
    closeAll() {
      if (this.beforeRow && this.beforeTable) {
        this.$refs[this.beforeTable].toggleRowExpansion(this.beforeRow, false);
        this.beforeRow = null;
        this.beforeTable = "";
      }
    },
    cancelWithdraw(id) {
      this.$axios
        .post("/userAssets/withdrawCancel", { withdrawId: id })
        .then((res) => {
          if (res.data.code === this.errorCode.ok) {
            this.$message({
              type: "success",
              message: this.$t("user_assets.web_record.cancel_success"),
            });
            this.getTableData();
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
            });
          }
        });
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.el-dialog {
  background: #ffffff;
  border-radius: 10px 10px 10px 10px;
  .el-dialog__body {
    padding-top: 0px;
    position: relative;
  }
}
.box {
  display: flex;
  margin-top: 20px;
  flex-direction: column;
  /deep/.table-head {
    background: rgba(234, 235, 237, 0.5);
  }
  /deep/.table-head:first-child {
    border-radius: 6px 0px 0px 6px;
  }
  /deep/.table-head:last-child {
    border-radius: 0px 6px 6px 0px;
  }
  /deep/.table-cell {
    border: none;
  }
  /deep/ .el-table__body tr.current-row > td {
    background-color: rgba(225, 234, 255, 0.6) !important;
  }
  /deep/ .el-table--enable-row-hover .el-table__body tr:hover > td {
    background-color: rgba(225, 234, 255, 0.6) !important;
  }
}

.close-img {
  top: -10px;
  right: 20px;
  width: 12px;
  height: 12px;
  cursor: pointer;
  position: absolute;
}
.p1 {
  font-family: PingFang SC, PingFang SC;
  font-weight: 800;
  font-size: 24px;
  color: #333333;
  margin-right: 15px;
  .sel {
    color: #4063ff;
  }
  span {
    margin-left: 15px;
    cursor: pointer;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 15px;
    color: #333333;
  }
}
.pagination-box {
  text-align: center;
  margin-top: 60px;
  margin-bottom: 120px;
  /deep/ .btn-prev,
  /deep/ .btn-next,
  /deep/ .number {
    width: 44px;
    height: 44px;
    line-height: 44px;
    background: #ffffff;
    box-shadow: 0px 3px 10px 1px rgba(180, 180, 180, 0.06);
    border-radius: 6px 6px 6px 6px;
  }
  /deep/ .active {
    background-color: #4063ff !important;
  }
}
.filter-bar {
  display: flex;
  background-color: #ffffff;
  padding: 16px 0;
  margin-bottom: 16px;
  border-bottom: 1px solid #f0f0f0;

  .filter-item {
    display: flex;
    align-items: center;
    margin-right: 40px;
    position: relative;
    cursor: pointer;

    .filter-label {
      font-size: 14px;
      color: #999999;
      margin-right: 8px;
    }

    .filter-value {
      font-size: 14px;
      color: #333333;
      margin-right: 8px;
    }

    .filter-arrow {
      font-size: 12px;
      color: #cccccc;
      transition: transform 0.2s;

      &.open {
        transform: rotate(180deg);
      }
    }
  }

  .filter-item-coin {
    position: relative;
  }

  .filter-item-status {
    position: relative;
  }
}

.coin-type-dropdown {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  z-index: 100;
  min-width: 100px;

  .coin-option {
    padding: 12px 20px;
    border-bottom: 1px solid #f0f0f0;

    &:last-child {
      border-bottom: none;
    }

    &.active {
      background-color: #f0f5ff;

      .coin-text {
        color: #4063ff;
        font-weight: 600;
      }
    }

    .coin-text {
      font-size: 14px;
      color: #333333;
    }
  }
}

.flow-type-dropdown {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  z-index: 100;
  min-width: 150px;

  .flow-type-option {
    padding: 12px 20px;
    border-bottom: 1px solid #f0f0f0;

    &:last-child {
      border-bottom: none;
    }

    &.active {
      background-color: #f0f5ff;

      .flow-type-text {
        color: #4063ff;
        font-weight: 600;
      }
    }

    .flow-type-text {
      font-size: 14px;
      color: #333333;
    }
  }
}
</style>
